import React, { useState } from 'react';
import { useIntl, useParams, history } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import PlayStationTab from './page/playstation';
import XboxTab from './page/xbox';
import NintendoTab from './page/nintendo';
import { getValidActiveId } from '@/pages/intelligence/utils/commonUtils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import '@/pages/intelligence/assets/scss/StoreRanks/ConsoleRegion/index.scss';

import type { IBaseProps } from '@/pages/intelligence/types/common';

const { Content } = Layout;

const DEFAULT_TAB = 'playstation';

type IConsoleStoreRankTopTabsPageProps = IBaseProps;

const ConsoleStoreRankTopTabsPage: React.FC<IConsoleStoreRankTopTabsPageProps> = (props) => {
  const {} = props;
  const { tab: pathActiveId } = useParams<any>();
  const { formatMessage } = useIntl();

  const tabs = [
    {
      id: 'playstation',
      label: (
        <div className="dbi-tab-item">
          <SvgIcon className="dbi-tab-item-icon" type="table-tip2-stable" />
          <span className="dbi-tab-item-text">{formatMessage({ id: 'dbi_store_rank_console_playstation' })}</span>
        </div>
      ),
      component: PlayStationTab,
    },
    {
      id: 'xbox',
      label: (
        <div className="dbi-tab-item">
          <SvgIcon className="dbi-tab-item-icon dbi-tab-invert" type="table-tip1" />
          <span className="dbi-tab-item-text">{formatMessage({ id: 'dbi_store_rank_console_xbox' })}</span>
        </div>
      ),
      component: XboxTab,
    },
    {
      id: 'nintendo',
      label: (
        <div className="dbi-tab-item">
          <SvgIcon className="dbi-tab-item-icon dbi-tab-invert" type="table-tip3" />
          <span className="dbi-tab-item-text">{formatMessage({ id: 'dbi_store_rank_console_nintendo' })}</span>
        </div>
      ),
      component: NintendoTab,
    },
  ];

  const initialActiveId = getValidActiveId(pathActiveId, { tabs, defaultActiveId: DEFAULT_TAB });
  const [activeId, setActiveId] = useState(initialActiveId);

  const handleActive = (tab: { id: any }) => {
    const activeIdTmp = tab?.id || DEFAULT_TAB;
    setActiveId(activeIdTmp);
    history.replace(`/intelligence/storeRanks/ConsoleRegion/${activeIdTmp}`);
  };

  return (
    <Content className="dbi-page dbi-storeranks--console">
      <Content.Header
        className="dbi-header contentHead-normal"
        title={formatMessage({ id: 'dbi_store_rank_console_console_region' })}
      >
        <div className="header-tab">
          <Tabs ceiling newMarkIdsMappingKey="StoreRanksConsoleRegion" tabs={tabs} animated={false} activeId={activeId} onActive={handleActive} />
        </div>
      </Content.Header>

      <Content.Body full>
        <MarqueeBanner />
        {tabs.map((tab) => (
          <div key={tab?.id}>{tab?.id === activeId && <tab.component />}</div>
        ))}
      </Content.Body>
    </Content>
  );
};

export default ConsoleStoreRankTopTabsPage;
